module.exports = __webpack_public_path__ + "static/bbis-bio-pellets-min-736fc664fcaa42373307822bef1b08b7.jpg";